import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '././../logo.webp';
import { Auth } from 'aws-amplify';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between', // Align items horizontally
    backgroundColor: '#B3CDE6',
    color:'black'
  },
  appBar: {
    zIndex: 99,
    color: 'black',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  logo: {
    height: 45,
    width: 100,
  },
  logoutLink: {
    marginLeft: 'auto', // Pushes the link to the right
  },
}));

const TopMenu = ({ sideMenuOpen, setSideMenuOpen }) => {
  const classes = useStyles();
  const [userName, setUserName] = React.useState('');
  const handleSideMenuToggle = () => {
    setSideMenuOpen(!sideMenuOpen);
  };
  useEffect(() => {
    async function setUserInfo() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setUserName(user.attributes.email);
      } catch (error) {
        console.error('Error fetching user info', error);
      }
    }    
    setUserInfo();
  }, []); // The empty dependency array means this effect runs once on mount
  async function Logout() {
    try {
      await Auth.signOut();
      // Redirect or perform any other actions after successful logout
      // For example, you can use React Router to redirect to a specific route
      // window.location.href = '/login'; // Redirect to the login page
    } catch (error) {
      console.error('Error signing out', error);
    }
  }
  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.root}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          className={classes.menuButton}
          onClick={handleSideMenuToggle}
        >
          <MenuIcon />
        </IconButton>
        <img height={100} width={45} src={logo} alt="Logo" className={classes.logo} />
        <div className={classes.logoutLink}>
          Welcome {userName}<br/>
          <Link onClick={() => Logout()}>Logout</Link>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default TopMenu;
